import React, { useState, useRef } from 'react'
import { Form, Row, Col, Input, Button, Select } from 'antd'
import firebase from 'gatsby-plugin-firebase'
import { normalizePhoneNumberInput } from '../../../utils/form/normalize'
import SuccessModal from '../../../components/SuccessModal'

const ElevationCertOrderForm = () => {
  const formRef = useRef(null)
  const [loading2, setLoading] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)

  const handleECSubmit = values => {
    setLoading(true)
    values.timestamp = new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York'
    })

    // Replace all undefined values with empty strings
    const convertedString = JSON.stringify(values, function (key, value) {
      return value === undefined ? '' : value
    })
    const updatedValues = JSON.parse(convertedString)

    const eCertFormMessageObj = {
      to: updatedValues.email,
      bcc: [
        'info@nofloodflorida.com',
        'sophia@nofloodflorida.com',
        'nofloodflorida+7t5d67e@nofloodflorida-org.myfreshworks.com'
      ],
      template: {
        name: 'eCertFormTemplate',
        data: {
          ...updatedValues
        }
      }
    }

    firebase
      .firestore()
      .collection('eCertForm')
      .add(eCertFormMessageObj)
      .then(() => {
        setLoading(false)
        setIsModalVisible(true)
        formRef.current.resetFields()
      })
      .catch(error => console.log('Error adding document:', error))
  }

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo)
  }

  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 }
  }

  const handleOk = () => setIsModalVisible(false)
  const handleCancel = () => setIsModalVisible(false)

  return (
    <>
      <SuccessModal
        content="Form Submitted Successfully! Please check your email and/or spam folder for a confirmation. Remember to check with your local community or the referenced links on this page to see if an Elevation Certificate already exists for your property."
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        handleOk={handleOk}
      />
      <Form
        {...layout}
        ref={formRef}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={handleECSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[20, 0]}>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: 'Please input your name!' }]}
            >
              <Input
                className="round"
                size="large"
                allowClear={true}
                placeholder="John Doe"
              />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: 'Please input your email!'
                }
              ]}
            >
              <Input
                className="round"
                size="large"
                allowClear={true}
                placeholder="info@nofloodflorida.com"
                onInput={e =>
                  (e.target.value = ('' + e.target.value).toLowerCase())
                }
              />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              normalize={(value, prevValue, prevValues) =>
                normalizePhoneNumberInput(value, prevValue)
              }
              label="Phone"
              name="phone"
              rules={[
                { required: true, message: 'Please input your phone number.' }
              ]}
            >
              <Input
                className="round"
                size="large"
                allowClear={true}
                placeholder="(813) 213-0641"
              />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              label="Address (for Elevation Certificate)"
              name="address"
              rules={[
                { required: true, message: 'Please input your street address.' }
              ]}
            >
              <Input
                placeholder="123 Main St"
                className="round"
                size="large"
                onInput={e =>
                  (e.target.value = ('' + e.target.value).toUpperCase())
                }
                allowClear={true}
              />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              label="City"
              name="city"
              rules={[{ required: true, message: 'Please input your city.' }]}
            >
              <Input
                placeholder="Tampa"
                className="round"
                size="large"
                onInput={e =>
                  (e.target.value = ('' + e.target.value).toUpperCase())
                }
                allowClear={true}
              />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              label="State"
              name="state"
              rules={[{ required: true, message: 'Please input your state.' }]}
            >
              <Input
                placeholder="FL"
                className="round"
                size="large"
                onInput={e =>
                  (e.target.value = ('' + e.target.value).toUpperCase())
                }
                allowClear={true}
              />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              label="Zip Code"
              name="zipcode"
              rules={[
                { required: true, message: 'Please input your zip code.' }
              ]}
            >
              <Input
                placeholder="33624"
                className="round"
                size="large"
                allowClear={true}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label={
                <a
                  target="_blank"
                  href="/flood-insurance-quote"
                >
                  Interested in Flood Insurance Quotes? (Click to Learn More)
                </a>
              }
              name="insuranceQuote"
              rules={[{ required: true, message: 'Please select Yes or No.' }]}
            >
              <Select>
                <Select.Option value="yes">Yes</Select.Option>
                <Select.Option value="no">No</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Message" name="message">
              <Input.TextArea className="round" />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="end">
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="box-shadow"
              shape="round"
              size="large"
              loading={loading2}
            >
              Submit Order
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </>
  )
}

export default ElevationCertOrderForm
